<template>
    <div style="width: 100%; height: 100%;">
        <div class="custom-container">
            <v-row no-gutters justify="center">
                <v-col cols="12" md="8">
                    <v-card flat>
                        <v-card-title class="headline">
                            Nutzer editieren
                        </v-card-title>
                        <v-form ref="detailsForm">
                            <v-card flat>
                                <v-card-title>
                                    Details
                                    <v-spacer/>
                                    <v-btn small color="primary" outlined depressed v-if="readonly" @click="readonly = false">Bearbeiten</v-btn>
                                    <v-checkbox small color="primary" depressed hide-details v-if="!readonly" v-model="is_later" label="Änderung zu Zeitpunkt" class="mt-0 pt-0 mr-2">Speichern</v-checkbox>
                                    <v-btn small color="primary" depressed v-if="!readonly" @click="patchUser"
                                        :disabled="(is_later && !update_at)"
                                    >Speichern</v-btn>
                                </v-card-title>
                                <v-card-title v-if="is_later">
                                    <v-spacer/>
                                    <v-menu
                                        v-model="dateMenu"
                                        ref="menu"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        :nudge-right="40"
                                        offset-y
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                :value="createdFormatted"
                                                label="Datum der Änderung"
                                                prepend-inner-icon="mdi-calendar"
                                                v-bind="attrs"
                                                v-on="on"
                                                readonly
                                                outlined
                                                hide-details
                                                dense
                                                class="mt-0 pt-0"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="update_at" no-title scrollable locale="de" @input="dateMenu = false"/>
                                    </v-menu>
                                </v-card-title>
                                <v-card-text>
                                    <v-text-field
                                            label="E-Mail-Adresse"
                                            outlined
                                            v-model="user.email"
                                            :readonly="readonly"
                                    ></v-text-field>
                                    <v-text-field
                                            label="Personalnummer"
                                            outlined
                                            v-model="user.staff_number"
                                            :readonly="readonly"
                                    ></v-text-field>
                                    <v-text-field
                                            label="Vorname"
                                            outlined
                                            v-model="user.first_name"
                                            :readonly="readonly"
                                    ></v-text-field>
                                    <v-text-field
                                            label="Nachname"
                                            outlined
                                            v-model="user.last_name"
                                            :readonly="readonly"
                                    ></v-text-field>
                                    <v-autocomplete
                                            label="Vorgesetzte"
                                            v-model="user.supervisors"
                                            value="id"
                                            text
                                            multiple
                                            :items="listSupervisors"
                                            outlined
                                            deletable-chips
                                            chips
                                            :readonly="readonly"
                                    />
                                    <v-select
                                            label="Organisationseinheit"
                                            v-model="user.orga_unit_id"
                                            :items="orga_units"
                                            item-text="name"
                                            item-value="id"
                                            :readonly="readonly"
                                            outlined/>
                                    <v-label>Ist der Nutzer ruhend? (z. B. in Elternzeit, längere Krankheit)</v-label>
                                    <v-radio-group v-model="user.is_absent" row :readonly="readonly"
                                    >
                                        <v-radio label="Ruhend" :value="true"/>
                                        <v-radio label="Nicht ruhend" :value="false"/>
                                    </v-radio-group>
                                </v-card-text>
                            </v-card>
                            <v-card flat>
                                <v-card-title>
                                    Passwort
                                    <div v-if="!user.is_invited">
                                        <v-btn small color="secondary" class="ml-4" depressed @click="reinvite(true)">Einladen</v-btn>
                                    </div>
                                    <div v-else>
                                        <v-btn small outlined class="ml-4" style="pointer-events: none;">Ist eingeladen<v-icon>mdi-check</v-icon></v-btn>
                                        <v-btn small color="secondary" class="ml-4" depressed @click="reinvite">Erneut einladen</v-btn>
                                    </div>
                                    <v-spacer/>
                                    <v-btn small color="primary" depressed :disabled="savePasswordDisabled" @click="patchPassword">Speichern</v-btn>
                                </v-card-title>
                                <v-card-text>
                                    <v-text-field
                                            type="password"
                                            clearable
                                            label="Neues Passwort"
                                            outlined
                                            v-model="password"
                                    ></v-text-field>
                                    <v-text-field
                                            type="password"
                                            clearable
                                            :error-messages="passwordMatchError"
                                            label="Neues Passwort bestätigen"
                                            outlined
                                            v-model="password_confirmation"
                                    ></v-text-field>
                                </v-card-text>
                            </v-card>
                        </v-form>
                        <v-form ref="detailsForm">
                            <v-card flat>
                                <v-card-title>
                                    Rollen
                                </v-card-title>
                                <v-card-text>
                                    <v-select
                                            label="Rollen"
                                            multiple
                                            v-model="user.roles"
                                            :items="roles"
                                            outlined
                                            @change="patchRoles"
                                            deletable-chips
                                            chips
                                    />
                                </v-card-text>
                            </v-card>
                            <v-card flat>
                                <v-card-text>
                                    <v-dialog v-model="deleteDialog" persistent max-width="400">
                                        <template v-slot:activator="{ on, attrs}">
                                            <v-btn
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    outlined
                                                    block
                                                    color="error"
                                            >
                                                Löschen<v-icon>mdi-delete-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-title style="word-break: normal">
                                                Sind Sie sich sicher, dass Sie den Nutzer löschen wollen?
                                            </v-card-title>
                                            <v-card-actions>
                                                <v-spacer/>
                                                <v-btn color="success" outlined @click="deleteDialog = false">Abbrechen</v-btn>
                                                <v-btn color="error" depressed @click="deleteUser">Löschen</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-card-text>
                            </v-card>
                            <v-card flat v-if="user.changes_planned && user.changes_planned.length > 0">
                                <v-card-title>
                                    Geplante Änderungen
                                </v-card-title>
                                <v-card-text>
                                    <SettingsUsersEditChanges :changes="user.changes_planned" :listSupervisors="listSupervisors" :orga_units="orga_units"/>
                                </v-card-text>
                            </v-card>
                            <v-card flat v-if="user.changes && user.changes.length > 0">
                                <v-card-title>
                                    Änderungen
                                </v-card-title>
                                <v-card-text>
                                    <SettingsUsersEditChanges :changes="user.changes" :listSupervisors="listSupervisors" :orga_units="orga_units"/>
                                </v-card-text>
                            </v-card>
                        </v-form>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        props: [],
        name: "",
        data: () => ({
            dateMenu: false,
            is_later: false,
            update_at: '',
            deleteDialog: false,
            test: [],
            user: {},
            password: '',
            password_confirmation: '',
            users: [],
            readonly: true,
            orga_units: [],
            roles: [],
        }),
        created() {
            if (this.$route.params.id){
                this.getUser();
                this.getUsers();
                this.getOrgaUnits();
                this.getRoles();
            }
            else {
                this.$router.push({ name: 'Dashboard'});
            }
        },
        computed: {
            createdFormatted(){
                return this.update_at ? this.$moment(this.update_at).format('DD.MM.YYYY') : '';
            },
            savePasswordDisabled(){
                return !(this.password && this.password_confirmation && (this.password === this.password_confirmation))  ;
            },
            passwordMatchError () {
                if (this.password && this.password_confirmation){
                    return (this.password === this.password_confirmation) ? '' : 'Die Passwörter müssen übereinstimmen.';
                }
                else{
                    return '';
                }
            },
            listSupervisors(){
                return this.users.map(item => {
                    let staff_number = item.staff_number ? '(' + item.staff_number + ')' : '';
                    return {
                        value: item.id,
                        text: item.last_name + ', ' + item.first_name + staff_number
                    };
                });
            },

        },
        methods: {
            ...mapActions({}),
            reinvite(first){
                this.axios.post('/users/' + this.user.id + '/reinvite', {
                    'email' : this.user.email
                }).
                then(() => {
                    this.$toast.success('Die Einladung wurde erfolgreich erneut versendet!');
                    if (first){
                        this.getUser();
                    }
                })
                    .catch((error) => {
                        if (error.response.data && error.response.data.response && error.response.data.response === 'passwords.throttled'){
                            this.$toast.error('Sie haben vor kurzem eine Einladung versendet. Versuchen Sie es später erneut.');
                        }
                        else{
                            this.$toast.error('Die Einladung wurde nicht versendet.');
                        }

                    });
            },

            patchRoles(){
                this.axios.patch('/users/' + this.user.id + '/roles', {
                    'roles' : this.user.roles
                }).
                then(() => {
                    this.$toast.success('Die Änderungen wurden erfolgreich gespeichert!');
                })
                    .catch(() => {
                        this.$toast.error('Die Änderungen wurden nicht gespeichert.');
                    });
            },
            getUser(){
                this.axios.get('/users/' + this.$route.params.id).then( (response) => {
                    this.user = {...response.data.data};
                }).catch( (e) => {
                    console.log(e);
                    this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
                    this.$router.push({ name: 'Dashboard'});
                });
            },
            patchUser(){
                this.axios.patch('/users/' + this.user.id, {
                    'is_later' : this.is_later,
                    'update_at' : this.update_at,
                    'user' : this.user,
                    'supervisors' : this.user.supervisors
                }).then( () => {
                    this.$toast.success('Die Änderungen wurden erfolgreich gespeichert!');
                    this.is_later = false;
                    this.readonly = true;
                    this.update_at = '';
                    this.getUser();
                }).catch( (e) => {
                    console.log(e);
                    this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
                })
            },
            patchPassword(){
                this.axios.patch('/users/' + this.user.id, {
                    'password' : this.password,
                    'password_confirmation' : this.password_confirmation,
                }).then( () => {
                    this.$toast.success('Die Änderungen wurden erfolgreich gespeichert!');
                    this.readonly = true;
                }).catch( (e) => {
                    console.log(e);
                    this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
                });
            },
            deleteUser(){
                this.axios.delete('/users/' + this.user.id).then( () => {
                    this.$toast.success('Der Nutzer wurde erfolgreich gelöscht!');
                    this.$router.push({ name: 'SettingsUsers'});
                }).catch( (e) => {
                    console.log(e);
                    this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
                })
            },
            getOrgaUnits(){
                this.axios.get('/orga-units').then( (response) => {
                    this.orga_units = Object.values({...response.data.data});
                }).catch( (e) => {
                    console.log(e);
                    this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
                    this.$router.push({ name: 'Dashboard'});
                });
            },
            getRoles(){
                this.axios.get('/roles').then( (response) => {
                    this.roles = Object.values({...response.data});
                    this.roles = this.roles.map(item => {
                        var description;
                        if (item.name === 'employee'){
                            description = 'Mitarbeiter';
                        }
                        else if (item.name === 'supervisor'){
                            description = 'Vorgesetzter';
                        }
                        else if (item.name === 'hr-department'){
                            description = 'Personalabteilung';
                        }

                        else if (item.name === 'managing-board'){
                            description = 'Vorstand';
                        }

                        else if (item.name === 'system-admin'){
                            description = 'Systemadmin';
                        }

                        else if (item.name === 'ideasWorkbench'){
                            description = 'Werkbank';
                        }

                        else{
                            description = item.name;
                        }

                        return {
                            value: item.name,
                            text: description
                        }
                    });
                }).catch( (e) => {
                    console.log(e);
                    this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
                    this.$router.push({ name: 'Dashboard'});
                });
            },
            getUsers(){
                this.axios.get('/users').then( (response) => {
                    this.users = Object.values({...response.data.data.users});
                }).catch( () => {
                    this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
                    this.$router.push({ name: 'Dashboard'});
                });
            }
        },
    }
</script>

<style scoped>

</style>